import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indianNumber',
  standalone: true,
})
export class IndianNumberPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    return (value || 0).toLocaleString('en-IN');
  }
}
